import { render, staticRenderFns } from "./TermHistory.vue?vue&type=template&id=e725830e"
import script from "./TermHistory.vue?vue&type=script&lang=js"
export * from "./TermHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports